import { Component } from '@angular/core';

@Component({
  selector: 'app-reseller-intro-main',
  templateUrl: './reseller-intro-main.component.html',
  styleUrls: ['./reseller-intro-main.component.css']
})
export class ResellerIntroMainComponent {
  english:boolean=true;
  hindi:boolean=false;
  ngOnInit(): void {
    const storeVal = localStorage.getItem('selectedValue');
    if (storeVal == 'english') {
      this.english = true;
      this.hindi = false;
    }
    if (storeVal == 'hindi') {

      this.english = false;
      this.hindi = true;
    }

  }

}
